import { SSRContentStateManager } from '../src/SSRContentStateManager.ts';

export const ssrContentStateManager: SSRContentStateManager = new SSRContentStateManager();
